var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigurevolleyball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 19.9688 29.8477",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 29.8477,
    opacity: 0,
    width: 19.9688,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.77344 9.5625C8.17969 9.5625 9.33984 8.41406 9.33984 6.98438C9.33984 5.57812 8.17969 4.44141 6.77344 4.44141C5.35547 4.44141 4.21875 5.57812 4.21875 6.98438C4.21875 8.41406 5.35547 9.5625 6.77344 9.5625ZM0 15.2695C0 16.1836 0.949219 16.6172 1.6875 16.2422L5.78906 14.1797C5.98828 14.0742 6.21094 14.1914 6.25781 14.4023L7.45312 19.1836L5.57812 23.8711L1.16016 23.8711C0.527344 23.8711 0 24.3867 0 25.0195C0 25.6523 0.527344 26.168 1.16016 26.168L6.29297 26.168C6.82031 26.168 7.14844 25.957 7.40625 25.4883L9.90234 20.8711L11.2969 24.5508L6.86719 27.5273C6.33984 27.8789 6.1875 28.6172 6.53906 29.1211C6.89062 29.6367 7.55859 29.8125 8.13281 29.4258L13.3711 25.9453C13.7695 25.6875 13.957 25.3008 13.7812 24.5977L10.6875 12.2344C10.6172 11.9766 10.6875 11.7422 10.9805 11.5898L18.9727 7.59375C19.5469 7.32422 19.7812 6.62109 19.4883 6.04688C19.1953 5.47266 18.5156 5.25 17.9414 5.53125L2.30859 13.3477L2.30859 9.44531C2.30859 8.8125 1.80469 8.29688 1.16016 8.29688C0.527344 8.29688 0 8.8125 0 9.44531ZM16.1602 4.53516C17.4141 4.53516 18.4219 3.52734 18.4219 2.27344C18.4219 1.03125 17.4141 0 16.1602 0C14.8945 0 13.8867 1.03125 13.8867 2.27344C13.8867 3.52734 14.8945 4.53516 16.1602 4.53516Z",
    fill: "currentColor",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigurevolleyball);
export default __webpack_public_path__ + "static/media/figure.volleyball.a3b54ca45c4558e2ef43fea164edf932.svg";
export { ForwardRef as ReactComponent };